import axios from '../axios/axios-auth'

export default class AlertsDictionaryService {

    getAllV3(orgId) {
        return axios.get(`/api/v3/organizations/${orgId}/alertsCatalog`).then(response => response.data)
    }

    saveV3(orgId, val) {
        return axios.post(`/api/v3/organizations/${orgId}/alertsCatalog`, val).then(response => response.data);
    }

    removeDescription(descriptionId) {
        return axios.delete(`/api/v3/alertsCatalog/${descriptionId}`).then(response => response.data);
    }
}
